import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relationship-sides" }
const _hoisted_2 = {
  key: 3,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_3 = { class: "relationship-sides" }
const _hoisted_4 = { class: "relationship-sides" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_select = _resolveComponent("ontos-select")!
  const _component_ontos_relationship_side = _resolveComponent("ontos-relationship-side")!
  const _component_ontos_pair_toggle = _resolveComponent("ontos-pair-toggle")!
  const _component_ontos_property_behavior = _resolveComponent("ontos-property-behavior")!
  const _component_ontos_property_default = _resolveComponent("ontos-property-default")!
  const _component_ontos_relationship_side_box = _resolveComponent("ontos-relationship-side-box")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_ontos_property_form_section = _resolveComponent("ontos-property-form-section")!
  const _component_ontos_property_form_layout = _resolveComponent("ontos-property-form-layout")!
  const _component_ontos_option_filter_input = _resolveComponent("ontos-option-filter-input")!
  const _component_ontos_rules_input = _resolveComponent("ontos-rules-input")!
  const _component_ontos_access_input = _resolveComponent("ontos-access-input")!
  const _component_ontos_property_tabs = _resolveComponent("ontos-property-tabs")!

  return (_openBlock(), _createBlock(_component_ontos_property_tabs, {
    ref: "tabs",
    validation: _ctx.hasValidation,
    invalid: _ctx.invalidTabs
  }, {
    property: _withCtx(() => [
      _createVNode(_component_ontos_property_form_layout, null, {
        top: _withCtx(() => [
          (_ctx.thisIsOwner && !_ctx.fixedDestinationClass)
            ? (_openBlock(), _createBlock(_component_ontos_select, {
                key: 0,
                items: _ctx.ideas.map(i => ({value: i.alias, text: i.name})),
                label: _ctx.$tt('relationship-collection'),
                class: "required",
                "hide-details": "auto",
                "error-messages": _ctx.destinationError,
                modelValue: _ctx.model.relationshipIdea,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.relationshipIdea) = $event))
              }, null, 8, ["items", "label", "error-messages", "modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sides, (side, index) => {
              return (_openBlock(), _createBlock(_component_ontos_relationship_side_box, {
                key: side.key,
                idea: side.idea,
                here: index === 0
              }, {
                default: _withCtx(() => [
                  (side.togglable)
                    ? (_openBlock(), _createBlock(_component_ontos_pair_toggle, _mergeProps({
                        key: 0,
                        "model-value": _ctx.mirrorOn
                      }, { ref_for: true }, _ctx.mirrorPair, {
                        disabled: !!_ctx.ownerModel.computed,
                        "disabled-reason": _ctx.ownerModel.computed ? _ctx.$tt('relationship.mirror-needs-filled') : '',
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mirrorOn = $event))
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_ontos_relationship_side, _mergeProps({
                            ref_for: true,
                            ref: "sides"
                          }, { ref_for: true }, side.fields), null, 16)
                        ]),
                        _: 2
                      }, 1040, ["model-value", "disabled", "disabled-reason"]))
                    : (_openBlock(), _createBlock(_component_ontos_relationship_side, _mergeProps({
                        key: 1,
                        ref_for: true,
                        ref: "sides"
                      }, { ref_for: true }, side.fields), null, 16)),
                  (side.behavior)
                    ? (_openBlock(), _createBlock(_component_ontos_property_behavior, {
                        key: 2,
                        model: side.behavior.model,
                        original: side.behavior.original,
                        kind: side.behavior.kind,
                        "cardinality-hint": side.sentence,
                        "compute-blocked": _ctx.mirrorOn ? _ctx.$tt('relationship.computed-needs-no-mirror') : '',
                        onMultiple: ($event: any) => (side.behavior.model.multiple = $event)
                      }, null, 8, ["model", "original", "kind", "cardinality-hint", "compute-blocked", "onMultiple"]))
                    : (side.sentence)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(side.sentence), 1))
                      : _createCommentVNode("", true),
                  (side.key === 'owner' && !side.model.computed && _ctx.mirrorIdea)
                    ? (_openBlock(), _createBlock(_component_ontos_property_default, {
                        key: 4,
                        ref_for: true,
                        ref: "default",
                        value: side.model.default,
                        draft: side.draft,
                        bindings: side.bindings,
                        "result-label": _ctx.formulaResultLabel,
                        onInput: ($event: any) => (side.model.default = $event)
                      }, null, 8, ["value", "draft", "bindings", "result-label", "onInput"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["idea", "here"]))
            }), 128))
          ]),
          (_ctx.ownerModel.computed)
            ? (_openBlock(), _createBlock(_component_ontos_property_form_section, {
                key: 1,
                title: _ctx.$tt('section.computation')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_formula_input, _mergeProps({
                    ref: "formula",
                    class: "required"
                  }, _ctx.formulaBindings, {
                    value: _ctx.ownerModel.formula,
                    "result-label": _ctx.formulaResultLabel,
                    draft: _ctx.draftOf(_ctx.ownerValue),
                    example: _ctx.computedExample,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ownerModel.formula = $event)),
                    onValidity: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formulaValid = $event))
                  }), null, 16, ["value", "result-label", "draft", "example"])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    validation: _withCtx(() => [
      _createVNode(_component_ontos_property_form_layout, null, {
        top: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.writtenSides, (side, index) => {
              return (_openBlock(), _createBlock(_component_ontos_relationship_side_box, {
                key: side.key,
                idea: side.idea,
                name: side.model.name,
                here: index === 0
              }, {
                default: _withCtx(() => [
                  (_ctx.canHaveRulesOn(side.model))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_ontos_property_form_section, {
                          title: _ctx.$tt('option-filter'),
                          explain: _ctx.$tt('option-filter-explain')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ontos_option_filter_input, {
                              ref_for: true,
                              ref: "optionFilter",
                              bindings: side.bindings,
                              draft: side.draft,
                              example: side.examples.optionFilter,
                              value: side.model.optionFilter,
                              onInput: ($event: any) => (side.model.optionFilter = $event),
                              message: side.model.optionFilterMessage,
                              onMessage: ($event: any) => (side.model.optionFilterMessage = $event)
                            }, null, 8, ["bindings", "draft", "example", "value", "onInput", "message", "onMessage"])
                          ]),
                          _: 2
                        }, 1032, ["title", "explain"]),
                        _createVNode(_component_ontos_property_form_section, {
                          title: _ctx.$tt('rules'),
                          explain: _ctx.$tt('rules-explain')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ontos_rules_input, {
                              ref_for: true,
                              ref: "rules",
                              bindings: side.bindings,
                              draft: side.draft,
                              example: side.examples.rule,
                              rules: side.model.rules,
                              onInput: ($event: any) => (side.model.rules = $event)
                            }, null, 8, ["bindings", "draft", "example", "rules", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["title", "explain"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["idea", "name", "here"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    access: _withCtx(() => [
      _createVNode(_component_ontos_property_form_layout, null, {
        top: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.writtenSides, (side, index) => {
              return (_openBlock(), _createBlock(_component_ontos_relationship_side_box, {
                key: side.key,
                idea: side.idea,
                name: side.model.name,
                here: index === 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_access_input, _mergeProps({
                    ref_for: true,
                    ref: "access"
                  }, { ref_for: true }, _ctx.fieldAccessBindings(side.draft, side.idea, side.current || undefined), {
                    value: side.model.access || {},
                    onInput: ($event: any) => (side.model.access = $event)
                  }), null, 16, ["value", "onInput"])
                ]),
                _: 2
              }, 1032, ["idea", "name", "here"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["validation", "invalid"]))
}